import React, { useCallback, useRef } from "react";
import { useAppContext } from "../../AppProvider";
import ButtonUtility from "../../Components/Buttons/Utility";
import ButtonConfirm from "../../Components/Buttons/Confirm";
import InputBoxIcon from "../../Components/Inputs/InputIcon/InputIcon";
import { faLoader } from "../../utilities/fontawesomeIcons";
import Switch from "../../Components/Switches/Switch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WarehouseArticleSettings } from "../../Models/WarehouseArticleSettings";
import { getFieldError } from "../../utilities/utilities";
import { useIndexWarehouseArticlesContext } from "../WarehouseArticles/providers/Index";
import { useWarehouseArticleSettingsHandlerContext } from "./provider/hooks";
import ButtonDelete from "../../Components/Buttons/Delete";
import { createModalConfig, ModalConfig } from "../../Models/ModalConfig";
import { Modal, ModalBody } from "reactstrap";
import { WarehouseArticleSettingsDeleteProvider } from "./provider/WarehouseArticleSettingsDeleteProvider";
import WarehouseArticleSettingsDelete from "./WarehouseArticleSettingsDelete";

const Handler = () => {
  const { dictionary } = useAppContext();
  const listRef = useRef<{ refresh: () => void } | null>(null);
  const { data, error, loader, callback, saveWarehouseArticleSettings } =
    useWarehouseArticleSettingsHandlerContext();
  const indexWarehouseArticlesContext = useIndexWarehouseArticlesContext();
  const warehouseArticleSettingsHandlerContext =
    useWarehouseArticleSettingsHandlerContext();
  const modalConfigWarehouseArticles =
    indexWarehouseArticlesContext.modalConfig;

  const modalConfigWarehouseArticlesSettings =
    warehouseArticleSettingsHandlerContext.modalConfig;
  const setModalConfigWarehouseArticlesSettings =
    warehouseArticleSettingsHandlerContext.setModalConfig;

  const handleChange = (
    name: string,
    value: string | boolean | number | object | null,
    key: string,
  ) => {
    saveWarehouseArticleSettings(
      {
        ...data,
        [name]: value,
      } as WarehouseArticleSettings,
      key as keyof WarehouseArticleSettings,
      false,
    );
  };

  const openModal = useCallback(
    (
      action: ModalConfig["action"],
      data?: any[],
      size: ModalConfig["size"] = "sm",
      className = "",
      title = "",
    ) => {
      warehouseArticleSettingsHandlerContext?.setModalConfig({
        isOpen: true,
        action,
        size,
        data,
        className,
        title,
      });
    },
    [warehouseArticleSettingsHandlerContext],
  );

  const closeModal = () => {
    if (callback) callback();
  };

  return (
    <React.Fragment>
      {loader ? (
        <div className="text-center mt-2">
          <FontAwesomeIcon icon={faLoader} spin size="2x" />
        </div>
      ) : (
        <React.Fragment>
          <div
            className={`d-flex ${data.id ? "justify-content-between" : "justify-content-center"}`}
          >
            <h3 className="text-center ">
              {modalConfigWarehouseArticles?.title}
            </h3>
            {data.id && (
              <ButtonDelete
                onClick={() => {
                  openModal(
                    "deleteUnderstock",
                    [data.id],
                    "sm",
                    "",
                    dictionary.actions.delete,
                  );
                }}
              ></ButtonDelete>
            )}
          </div>

          <div className="mb-2">
            <label className="label-2">
              {dictionary.registries.low_stock_threshold}
            </label>
            <InputBoxIcon
              name="lowStockThreshold"
              value={data.lowStockThreshold || ""}
              placeholder={"100"}
              type="positive-integer-number"
              onChange={({ target }) => {
                handleChange(target.name, target.value, "lowStockThreshold");
              }}
              error={getFieldError(error, "lowStockThreshold")}
            />
          </div>
          <div className="mb-3">
            <label className="label-2">
              {dictionary.registries.email_list}
            </label>
            <InputBoxIcon
              name="notificationEmails"
              value={data.notificationEmails || ""}
              placeholder={"example@mail.com, example@mail.it, ..."}
              type="email"
              onChange={({ target }) => {
                handleChange(target.name, target.value, "notificationEmails");
              }}
              error={getFieldError(error, "notificationEmails")}
            />
          </div>

          <div>
            <div className="text-end">
              <Switch
                name="enabled"
                checked={data.enabled ?? false}
                onChange={(e) => {
                  handleChange(e.target.name, !data.enabled, "enabled");
                }}
                label={dictionary.words.active}
              />
            </div>
          </div>
          <div className="d-flex mt-3">
            <ButtonUtility
              className="w-50 me-2"
              onClick={() => {
                if (callback) {
                  callback();
                }
              }}
              disabled={loader}
            >
              {dictionary.words.back}
            </ButtonUtility>
            <ButtonConfirm
              className="w-50"
              onClick={() =>
                saveWarehouseArticleSettings(
                  data as WarehouseArticleSettings,
                  "id",
                  true,
                )
              }
              disabled={loader}
              loading={loader}
            >
              {dictionary.actions.save}
            </ButtonConfirm>
          </div>
        </React.Fragment>
      )}
      <Modal
        isOpen={modalConfigWarehouseArticlesSettings.isOpen}
        size={modalConfigWarehouseArticlesSettings.size}
      >
        <ModalBody
          className={modalConfigWarehouseArticlesSettings.className || ""}
        >
          {modalConfigWarehouseArticlesSettings.action ===
            "deleteUnderstock" && (
            <>
              <WarehouseArticleSettingsDeleteProvider
                data={modalConfigWarehouseArticlesSettings?.data}
                callback={() => {
                  listRef.current?.refresh();
                  closeModal();
                }}
              >
                <WarehouseArticleSettingsDelete
                  onBack={() => {
                    setModalConfigWarehouseArticlesSettings(
                      createModalConfig(),
                    );
                  }}
                />
              </WarehouseArticleSettingsDeleteProvider>
            </>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default Handler;
